import React from 'react';
import Link from '../../../components/LocalizedLink';

const toitlustus = {
	'toitlustus.pealkiri': 'Catering',
	'toitlustus.blokk1': () => (
		<>
			<h2 className='title is-2'>Holiday Village kitchen</h2>
			<p>We offer dinner and catering services only if you pre-order them.</p>
			<p>
				All our delicious food is made in our small kitchen by our great cooks.
			</p>
			<div className='columns'>
				<div className='column is-6'>
					<ul>
						<li>Wedding table </li>
						<li>Party table </li>
						<li>Birthday table </li>
						<li>Funeral Table </li>
						<li>Conference coffee breaks</li>
					</ul>
				</div>
				<div className='column is-6'>
					<ul>
						<li>Breakfast, Lunch and Dinner</li>
						<li>Sauna snacks</li>
						<li>Picnic baskets</li>
						<li>Catering</li>
						<li>and more</li>
					</ul>
				</div>
			</div>
			<p>
				In the summer season, the dinner usually is at 19:00. Breakfast and
				lunch variates. You have to preorder your meals.
			</p>
			<p>
				Daily menu is the same for every guest, but if you are allergic to
				something, then we will find something to you aswell.
			</p>
			<p>
				In the winter season, we don´t serve dinner and lunch, but we have
				really nice <Link to='/majutus/ridaelamud'>apartments</Link> where,
				there is a kitchen, so you could make something for yourself.
			</p>
		</>
	)
};

export default toitlustus;
